import React from 'react'
import { Badge } from '@awell-health/design-system'
import type { Activity } from '../../../types'
import { t } from 'i18next'
import { ActivityObjectType, ActivityResolution } from '../../../../../generated/types-orchestration'

export const AgentDoneBadge = () => {
  return (
    <Badge variant="success" size="md">
      <div className="h-2 w-2 bg-green-700 rounded-full mr-2" />
      {t('activityfeed:agent_badge_completed')}
    </Badge>
  )
}

export const AgentFailedBadge = () => {
  return (
    <Badge variant="error" size="md">
      <div className="h-2 w-2 bg-red-700 rounded-full mr-2" />
      {t('activityfeed:agent_badge_failed')}
    </Badge>
  )
}

const needsBadge = (activity: Activity): boolean => {
  return activity.object.type === ActivityObjectType.Agent && activity.action !== 'ACTIVATE'
}

export const AgentCardDesription = ({ activity }: { activity: Activity }) => {
  return (
    <div className="self-stretch p-3 bg-slate-100 rounded-lg text-sm text-slate-800 flex flex-col gap-2">
      {needsBadge(activity) && activity.resolution === ActivityResolution.Success && <AgentDoneBadge />}
      {needsBadge(activity) && activity.resolution === ActivityResolution.Failure && <AgentFailedBadge />}
      {activity.sub_activities[0]?.text?.en && activity.sub_activities[0].text.en}
    </div>
  )
}
